import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

const useShipmentEditPermission = () => {
  const shipmentStatus = useSelector((state) => state.shipment.shipmentDetails.data?.status, shallowEqual);
  const permission = useMemo(() => {
    const disabledStatus = ['Closed'];
    if (disabledStatus.includes(shipmentStatus)) {
      return false;
    }
    return true;
  }, [shipmentStatus]);
  return permission;
};

export default useShipmentEditPermission;
